import React from "react";
import KiotOrdersComponent from "../KiotOrders/KiotOrdersComponent";


const KiotImportOrders = props => {
    return <KiotOrdersComponent tab={1} status={'1,5'} screenTitle={'Nhận hàng từ nhà cung cấp'}/>
};

export default KiotImportOrders;
